import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext(null);

const DEFAULT_LANGUAGE = 'en';

const getNestedTranslation = (source, path) => {
  return path.split('.').reduce((value, key) => value?.[key], source);
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window === 'undefined') {
      return DEFAULT_LANGUAGE;
    }

    return window.localStorage.getItem('language') || DEFAULT_LANGUAGE;
  });

  useEffect(() => {
    window.localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  const value = useMemo(() => ({
    language,
    setLanguage,
    t: (path) => getNestedTranslation(translations[language], path) ?? getNestedTranslation(translations[DEFAULT_LANGUAGE], path) ?? path,
  }), [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }

  return context;
};
